
import Header from "../Components/Header";
import Hero from "../Layout/Hero";
import Category from "../Layout/Category";
import Prodcuts from "../Components/Products";
import SectionHeader from "../Components/SectionHeader";
import Rug from "../Layout/Rug";
import About from "../Layout/About";
import BestsellingProducts from "../Layout/BestsellingProducts";
import BgCta from "../Layout/BgCta";
import Testimonial from "../Layout/Testimonial";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";



function Home() {
  return (
    <>
      <Header mode="light" />
      <Hero />

      <SectionHeader
        title="Shop By Category"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Category />

      <SectionHeader
        title="Home Textiles"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Prodcuts />

      <SectionHeader
        title="Carpets & Rugs"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Prodcuts />

      <SectionHeader
        title="Rug By Room"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Rug />

      <SectionHeader
        title="Lifestyle apparel"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Prodcuts />

      <SectionHeader
        title="Home Decor"
        subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />

      <Prodcuts />

      <About />

      <BestsellingProducts />
      <BgCta />

    <Testimonial />

    <Feature />

    <Footer />

    </>
  );
}

export default Home;
